import { FormControl, FormGroup } from 'react-bootstrap';
import { FormikErrors } from 'formik';
import { checkValueOrThrowError, isString, StringKeysOf } from '@arnold/common';
import { FormErrorFeedback, FormGroupLabel } from '../../../../components/Common';
import { ValueType } from './types';

// @todo - move me if needed
type SelectInputProps<V extends ValueType> = {
  errors: FormikErrors<V>;
  setFieldValue: (key: StringKeysOf<V>, value: string) => void;
  values: V;
  title: string;
  name: StringKeysOf<V>;
  options: Array<{ value: string; title: string }>;
};
export const SelectInput = <V extends ValueType>({
  title,
  name,
  values,
  errors,
  setFieldValue,
  options,
}: SelectInputProps<V>): JSX.Element => {
  return (
    <FormGroup>
      <FormGroupLabel>{title}</FormGroupLabel>
      <FormControl
        as="select"
        name={title}
        value={checkValueOrThrowError(values[name], isString) || undefined}
        onChange={(e) => {
          setFieldValue(name, e.target.value);
        }}
        isInvalid={!!errors[name]}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.title}
          </option>
        ))}
      </FormControl>
      {errors[name] && <FormErrorFeedback error={errors[name]} />}
    </FormGroup>
  );
};
